import { createUserManager } from "redux-oidc-2";

export const clientSettings = {
  authority: process.env.REACT_APP_AUTH_SERVICE,
  client_id: "bettybois-ui",
  redirect_uri: `${process.env.REACT_APP_AUTH_REDIRECT}/signin-oidc`,
  post_logout_redirect_uri: `${process.env.REACT_APP_AUTH_REDIRECT}/signout-callback-oidc`,
  response_type: "code",
  scope:
    "openid profile email betting.read betting.write payments.read payments.write",
  filterProtocolClaims: true,
  loadUserInfo: true,
  automaticSilentRenew: true,
  silent_redirect_uri: `${process.env.REACT_APP_AUTH_REDIRECT}/silent-refresh`,
};

export const userManager = createUserManager(clientSettings);
